import {Component, Inject, OnInit} from '@angular/core';
import {InternalService} from '../../../shared/services/internal.service';
import {ApiService} from '../../../shared/services/api.service';
import {CookieService} from 'ngx-cookie-service';
import { ChatService } from 'src/app/shared/services/chat.service';

declare interface RouteInfo {
  id: number;
  path: string;
  title: string;
  icon: string;
  class: string;
  role: any;
}

export const ROUTES: RouteInfo[] = [
  {
    id: 111,
    path: '/manager/users',
    title: 'Users',
    icon: 'fa-user',
    class: '',
    role: ['Admin', 'Administrator','Agent']
  },
  // {
  //   id: 112,
  //   path:'/manager/authentication',
  //   title:'Authentication',
  //   icon:'fa-user-times',
  //   class:'',
  //   role:['Admin', 'Administrator','Corroborator']
  // },
  // {
  //   id: 113,
  //   path: '/manager/supervisor-requests',
  //   title: 'SupervisorRequests',
  //   icon: 'fa-briefcase',
  //   class: '',
  //   role: ['Admin', 'Administrator','Corroborator']
  // },
  {
    id: 114,
    path: '/manager/categories',
    title: 'Categories',
    icon: 'fa-list-alt',
    class: '',
    role: ['Admin', 'Administrator','Agent']
  },
  // {
  //   path: '/manager/corroborations',
  //   title: 'Corroborations',
  //   icon: 'fa-tasks',
  //   class: '',
  //   role: ['Admin', 'Corroborator', 'Administrator']
  // },
  {
    id: 115,
    path: '/manager/services',
    title: 'Services',
    icon: 'fa-id-card',
    class: '',
    role: ['Admin', 'Administrator','Agent']
  },
  {
    id: 116,
    path:'/manager/skill-confirmation',
    title:'SkillConfirmation',
    icon:'fa-check',
    class:'',
    role:['Admin', 'Administrator','Corroborator']
  },
  {
    id: 117,
    path: '/manager/marketer',
    title: 'Marketer',
    icon: 'fa fa-users',
    class: '',
    role: ['Admin', 'Administrator', 'Marketer']
  },
  {
    id: 118,
    path: '/manager/moderator',
    title: 'ImageManagement',
    icon: 'fa-edit',
    class: '',
    role: ['Admin', 'Moderator', 'Administrator']
  },



  // {
  //   path: '/manager/agent',
  //   title: 'Agent',
  //   icon: 'fa-user-secret',
  //   class: '',
  //   role: ['Admin', 'Agent', 'Administrator']
  // },


  {
    id: 119,
    path: '/manager/reports',
    title: 'Reports',
    icon: 'fa-file',
    class: '',
    role: ['Admin', 'Administrator']
  },


  {
    id: 120,
    path: '/manager/rating',
    title: 'Rating',
    icon: 'fa-question',
    class: '',
    role: ['Admin', 'Administrator']
  },
  {
    id: 121,
    path: '/manager/feedback',
    title: 'FeedBack',
    icon: 'fa-comments',
    class: '',
    role: ['Admin', 'Administrator']
  },
  {
    id: 122,
    path: '/manager/audits',
    title: 'Audits',
    icon: 'fa-id-card',
    class: '',
    role: ['Admin', 'Administrator']
  },
  {
    id: 123,
    path: '/manager/financial',
    title: 'financialAffairs',
    icon: 'fa-money',
    class: '',
    role: ['Admin', 'Administrator']
  },
  {
    id: 124,
    path: '/manager/information',
    title: 'Information',
    icon: 'fa-line-chart',
    class: '',
    role: ['Admin', 'Administrator']
  },

  {
    id: 125,
    path: '/manager/setting',
    title: 'GeneralSettings',
    icon: 'fa-cog',
    class: '',
    role: ['Admin', 'Administrator']
  },
  {
    id: 126,
    path: '/manager/messages',
    title: 'Messages',
    icon: 'fa-envelope',
    class: '',
    role: ['Admin', 'Administrator']
  }
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];
  test: Date = new Date();
  flag: any;
  msgCount: number = 0;

  constructor(private internalService: InternalService,
    public apiService: ApiService,
    private  cookieService: CookieService,
    private message:ChatService
  ) {
    if (this.cookieService.get('dir') != undefined) {
      this.apiService.currentDirection = this.cookieService.get('dir');
      if (this.apiService.currentDirection === 'rtl') {
        this.internalService.changeLang('fa-ir', 0);
      } else {
        this.internalService.changeLang('en-us', 0);
      }
    }
  }

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);

    this.message.getMessageCount$().pipe().subscribe((number: any) => {
      this.msgCount = number;
    })
  }

  isMobileMenu() {
    if (window.innerWidth > 991) {
      return false;
    }
    return true;
  }

  isAuthorized(role, path) {
    this.flag = false;
    const rolesArray = JSON.parse(this.cookieService.get('currentUserRoles'));
    for (let i = 0; i < rolesArray.length; i++) {
      if (role.includes(rolesArray[i])) {
        this.flag = true;
        break;
      }
    }

    return this.flag;

    // if (this.flag) {
    //     return true;
    //   }else {
    //   return false;
    // }
    // if (role.indexOf(this.cookieService.get('currentUser')) === -1) {
    //   return false;
    // } else {
    //   return true;
    // }

  }
}

